import { faVialCircleCheck, faWarehouse, faTruck, faWarehouseFull, faTableColumns, faFolderOpen, faSitemap, faCartArrowDown, faRadar, faBuildingMemo } from "@fortawesome/pro-solid-svg-icons";
import { faArrowDownFromBracket, faGear, faList, faRectangleHistoryCirclePlus, faShip, faShop, faUsers } from "@fortawesome/pro-solid-svg-icons";
import { PURCHASE_ORDER_ROOT, WAREHOUSE_SETTINGS_ROOT } from "../../pages/RouteConstants";

const MenuConfig = [
  {
    key: "/delivery-planner",
    icon: faTableColumns,
    label: "Delivery Planner",
    isParent: true,
  },
  {
    key: "2",
    icon: faShip,
    label: "Shipment",
    isParent: true,
    defaultOpen: true,
    children: [
      { key: "/shipment-gateway", icon: faList, label: "Gateway" },
      {
        key: "/shipment",
        icon: faRectangleHistoryCirclePlus,
        label: "New Shipment",
      },
    ],
  },
  {
    key: "warehouse-shipment",
    icon: faWarehouse,
    label: "Warehouse",
    isParent: true,
    defaultOpen: true,
    children: [
      {
        key: "/warehouse-unloading-plan",
        icon: faTruck,
        label: "Unloading Plan",
      },
      {
        key: "/containers-on-site",
        icon: faBuildingMemo,
        label: "Containers On Site",
      },
    ],
  },
  {
    key: "/detention",
    icon: faRadar,
    label: "Detention",
    isParent: true,
  },
  {
    key: "/document",
    icon: faFolderOpen,
    label: "Documents",
    isParent: true,
  },
  {
    key: "/purchase-order-menu",
    icon: faCartArrowDown,
    label: "Purchase Order",
    isParent: true,
    children: [
      {
        key: PURCHASE_ORDER_ROOT,
        icon: faList,
        label: "Gateway",
      },
      {
        key: `${PURCHASE_ORDER_ROOT}/new`,
        icon: faRectangleHistoryCirclePlus,
        label: "New Purchase Order",
      },
    ],
  },
  {
    key: "3",
    icon: faGear,
    label: "Settings",
    isParent: true,
    defaultOpen: false,
    children: [
      { key: "/settings/org-profile", icon: faSitemap, label: "Org Profile", privilege: "OrgProfilePage" },
      { key: "/settings/user-roles", icon: faUsers, label: "User", privilege: "UserPage" },
      { key: "/settings/supplier", icon: faShop, label: "Supplier", privilege: "SupplierPage" },
      { key: "/settings/org", icon: faSitemap, label: "Org", privilege: "OrgPage" },
      {
        key: "/settings/freight-forwarder",
        icon: faArrowDownFromBracket,
        label: "Freight Forwarder",
        privilege: "ForwarderPage",
      },
      { key: WAREHOUSE_SETTINGS_ROOT, icon: faWarehouseFull, label: "Warehouse", privilege: "WarehousePage" },
    ],
  },
  {
    key: "test-section",
    icon: faVialCircleCheck,
    label: "Test",
    privilege: "TestingPage",
    isParent: true,
    defaultOpen: false,
    children: [
      { key: "/test/run-tests", icon: faVialCircleCheck, label: "Run Tests" },
    ],
  },
];

export default MenuConfig;
//